import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import DashboardComponent from './DashboardComponent';

import CustomExportsTable from '../reports/Exports/CustomExportsTable';
import useViewableCustomExports from '../reports/Exports/useViewableCustomExports';

export default function DashboardCustomExportWidget({
  onDelete,
  isEdit,
  exportId,
  height,
}) {
  const [viewableCustomExports] = useViewableCustomExports();
  const ourExport = useMemo(
    () => viewableCustomExports.find((e) => e.id === exportId),
    [viewableCustomExports, exportId],
  );

  const [headerHeight, setHeightHeight] = useState(32);

  const onHeaderResize = useCallback((e) => {
    const { height: newHeight } = e ?? {};
    if (!newHeight) return;
    setHeightHeight(newHeight);
  }, []);

  return (
    <DashboardComponent
      title={ourExport?.title}
      onDelete={onDelete}
      isEdit={isEdit}
    >
      <div
        style={{
          height: 'calc(100% - 40px)',
          marginTop: 10,
          width: '100%',
          paddingBottom: 5,
        }}
      >
        <CustomExportsTable
          key={ourExport?.id}
          selectedExport={ourExport}
          scroll={height - (headerHeight - 32)}
          onHeaderResize={onHeaderResize}
          canFilter
        />
      </div>
    </DashboardComponent>
  );
}

/* eslint-disable react/forbid-prop-types */
DashboardCustomExportWidget.propTypes = {
  exportId: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  height: PropTypes.number.isRequired,
};

DashboardCustomExportWidget.defaultProps = {
  isEdit: false,
};
